import { render, staticRenderFns } from "./task-appeal-detail.vue?vue&type=template&id=05b3b333&"
import script from "./task-appeal-detail.vue?vue&type=script&lang=js&"
export * from "./task-appeal-detail.vue?vue&type=script&lang=js&"
import style0 from "./task-appeal-detail.vue?vue&type=style&index=0&lang=less&scroped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports